<div class="row"
     *ngFor="let i of items">
  <ng-container *ngIf="isArray(i.item)" >
    <div class="col-md-6"
         *ngFor="let item of i.item; let index = index;">
      <app-contact-display *ngIf="i.page.item === 'contacts'" [item]="item"
                           [meta]="i.meta.child.fields"></app-contact-display>
      <div *ngIf="i.page.item !== 'contacts'" class="panel panel-default">
        <div class="panel-heading">
        <span *ngIf="item.hasOwnProperty('relationship_type')">
          {{ item.relationship_type | display:i.meta.child.fields['relationship_type'].choices }}
        </span>
          <span *ngIf="!item.hasOwnProperty('relationship_type')">
          {{ i.meta.label }} #{{ index + 1 }}
        </span>
        </div>
        <div class="panel-body">
            <span *ngFor="let key of getFilteredFields(i.page)">

                <b><span
                  [innerHtml]="i.meta.child.fields[key].label"></span></b>:
                <app-display-field [value]="item[key]"
                                   [type]="i.meta.child.fields[key].type"
                                   [choices]="i.meta.child.fields[key].choices"></app-display-field>
              <!--                <b *ngIf="item.errors[key].errorMessage !== undefined"-->
              <!--                   style="color: #a94442;">{{ item.errors[key].errorMessage }}</b>-->
<br/>
            </span>
          <span *ngIf="item.shape">
<!--                <b *ngIf="item.errors && item.errors?.shape.errorMessage !== undefined"-->
            <!--                   style="color: #a94442;">{{ item.errors?.shape.errorMessage }}<br/></b>-->
                <b>Latitude: </b> {{ item.coordinates.y }}<br/>
                <b>Longitude: </b> {{ item.coordinates.x }}<br/>
            </span>
        </div>
      </div>
    </div>
  </ng-container>
  <div [ngClass]="{'col-sm-12': i.item.hasOwnProperty('shape'),
                  'col-sm-6': !i.item.hasOwnProperty('shape')}"
       *ngIf="!(i.item | isArray)">
    <div class="panel panel-default">
      <div class="panel-heading">
        {{ i.meta.label }}
      </div>
      <div class="panel-body">
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <span *ngFor="let key of getFilteredFields(i.page)">
                <b>{{ i.meta.fields[key].label }}</b>: <app-display-field
              [value]="i.item[key]"
              [type]="i.meta.fields[key].type"
              [choices]="i.meta.fields[key].choices"></app-display-field>
              <!--                <b *ngIf="i.item.errors[key].errorMessage !== undefined"-->
              <!--                   style="color: #a94442;">{{ i.item.errors[key].errorMessage }}</b>-->
                <br/>
            </span>
<!--            <span *ngIf="i.item.shape">-->
<!--&lt;!&ndash;                <b *ngIf="i.item.errors?.shape.errorMessage !== undefined"&ndash;&gt;-->
<!--              &lt;!&ndash;                   style="color: #a94442;">{{ i.item.errors?.shape.errorMessage }}&ndash;&gt;-->
<!--              &lt;!&ndash;                  <br/></b>&ndash;&gt;-->
<!--                <b>Latitude: </b> {{ i.item.coordinates.y }}<br/>-->
<!--                <b>Longitude: </b> {{ i.item.coordinates.x }}<br/>-->
<!--            </span>-->
          </div>
          <div class="col-md-8 col-sm-12">
            <!--            todo: add code for map-->
            <!--            <div id="mapDiv" style="height:450px;">-->
            <!--              <div id="zoomToolbar" style="left:6px;" class="btn-toolbar">-->
            <!--                <div class="btn-group">-->
            <!--                  <button id="zoomIn-button" class="btn btn-primary" (click)="zoomIn()">-->
            <!--                    <span class="fa fa-plus"></span>-->
            <!--                  </button>-->
            <!--                  <button id="zoomOut-button" class="btn btn-primary" (click)="zoomOut()">-->
            <!--                    <i class="fa fa-minus"></i>-->
            <!--                  </button>-->
            <!--                </div>-->
            <!--                <div class="btn-group">-->
            <!--                  <button id="center-button" class="btn btn-primary" (click)="center()">-->
            <!--                    <span class="fa fa-home"></span>-->
            <!--                  </button>-->
            <!--                </div>-->
            <!--              </div>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div style="float:right;">
  <a *ngIf="previousPage" [routerLink]="['/','application', route.parent.snapshot.params.type, previousPage.item]">
    <button style="margin-right: 15px;" class="btn btn-default">
      Back
    </button>
  </a>

  <button (click)="submit()" class="btn btn-default" style="float: right;">Submit Application</button>
</div>
